export type ValidationTranslation = {
  charactersLimit: string;
  date: {
    isValid: string;
    maxCurrentDate: string;
    maxDate: string;
    minCurrentDate: string;
    mmDDFormat: string;
    notEarlierThen: string;
  };
  email: string;
  general: { required: string; wrongFormat: string };
  iban: string;
  incorrectFileExtension: string;
  integerNumber: string;
  isNumber: string;
  length: string;
  max: string;
  maxLength: string;
  maxLengthOfMessage: string;
  maxStringLength: string;
  min: string;
  minLength: string;
  minNumber: string;
  minStringLength: string;
  mobile: string;
  nip: string;
  noResults: string;
  passwordMustMatch: string;
  passwordRequirements: string;
  pesel: string;
  phone: string;
  pinsMustMatch: string;
  rating: string;
  regon: string;
  required: string;
  stringLength: string;
  tooLargeFileSize: string;
  year: string;
};

export const validationTranslation: ValidationTranslation = {
  charactersLimit: 'Maksymalna liczba znaków to {{noOfChars}}',
  date: {
    isValid: 'Podana data nie istnieje',
    maxCurrentDate: 'Data nie może być w przyszłości',
    maxDate: 'Data nie może być późniejsza niż {{maxDate}}',
    minCurrentDate: 'Data nie może być w przeszłości',
    mmDDFormat: 'Data musi być w formacie MM/DD',
    notEarlierThen: '{{to}} nie może być wcześniejsza niż {{from}}',
  },
  email: 'E-mail jest nieprawidłowy',
  general: {
    required: 'Pole jest wymagane',
    wrongFormat: 'Podano błędny format',
  },
  iban: 'Numer IBAN jest nieprawidłowy',
  incorrectFileExtension:
    'Nieprawidłowe rozszerzenie pliku. Obsługiwane rozszerzenia to: {{correctExtensions}}',
  integerNumber: 'Pole musi być liczbą całkowitą',
  isNumber: 'Pole musi być liczbą',
  length: 'Pole musi mieć długość {{length}}',
  max: 'Maksymalna wartość to {{max}}',
  maxLength: 'Pole może mieć maksymalnie {{max}} znaków',
  maxLengthOfMessage: 'Maksymalna długość wiadomości to {{max}} znaków',
  maxStringLength: 'Maksymalna długość tego pola to: {{max}}',
  min: 'Minimalna wartość to {{min}}',
  minLength: 'Pole musi mieć co najmniej {{min}} znaków',
  minNumber: 'Minimalna wartość dla tego pola to: {{minNumber}}',
  minStringLength: 'Minimalna długość tego pola to: {{min}}',
  mobile: 'Numer telefonu jest nieprawidłowy - dozwolone są tylko plus (+), myślniki (-) i cyfry',
  nip: 'Nieprawidłowa wartość NIP',
  noResults: 'Brak wyników',
  passwordMustMatch: 'Hasła muszą być takie same',
  passwordRequirements:
    'Hasła muszą zawierać jedną cyfrę, jedną małą literę, jedną wielką literę i jeden znak specjalny. Długość hasła musi być między 8 a 100 znakami.',
  pesel: 'Numer PESEL jest nieprawidłowy',
  phone: 'Numer telefonu jest nieprawidłowy (dozwolone cyfry i myślniki)',
  pinsMustMatch: 'PIN-y muszą być takie same',
  rating: 'Proszę wybrać swoją ocenę',
  regon: 'Nieprawidłowa wartość REGON',
  required: 'To pole jest wymagane',
  stringLength: 'To pole musi mieć {{length}} znaków',
  tooLargeFileSize: 'Rozmiar pliku jest za duży. Maksymalny rozmiar pliku to: {{maxFileSize}}',
  year: 'Podaj rok',
};
